







































































































































































































































































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import draggable from 'vuedraggable'
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import SimpleMenuTextEditor from "@/components/common/SimpleMenuTextEditor.vue";
import ModelFactorScoringDefinitionButtonTrigger
    from "@/components/scoring-definition/ModelFactorScoringDefinitionButtonTrigger.vue";
import ValueTypes from "@/utils/ValueTypes";
import { Factor, FactorGroup } from "@/api/model/FactorResource";
import Modelling from "@/store/modules/Modelling";
import Decisions from "@/store/modules/Decisions";


const decisionsModule = getModule(Decisions)
const modellingModule = getModule(Modelling);
const workspaceOptionsModule = getModule(WorkspaceOptions)
@Component({
    components: {
        ButtonModelScoringDefinitionTrigger: ModelFactorScoringDefinitionButtonTrigger,
        SimpleMenuTextEditor,
        ConfirmationDialog,
        draggable
    }
})
export default class ModelGrowingTableBuilder extends Vue {
    private readonly VALUE_TYPES = ValueTypes.VALUE_TYPES
    private readonly DATE_TIME_FORMATS = ValueTypes.DATE_TIME_FORMATS
    private readonly PREFIX_SUFFIX_VALUE_TYPES = ValueTypes.VALUE_TYPES_WITH_PREFIX_SUFFIX
    private readonly CATEGORY_FORMATS = ValueTypes.CATEGORY_FORMATS;
    private readonly TEXT_FORMATS = ValueTypes.TEXT_FORMATS;

    @Prop()
    tableFactorResource: FactorGroup;

    private creating = false;

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get factors() {
        return modellingModule.workingModelFactorResources;
    }

    get editModel() {
        return workspaceOptionsModule.editModel;
    }

    get editSumRule() {
        return workspaceOptionsModule.editSumRule;
    }

    get editScoringRule() {
        return workspaceOptionsModule.editScoringRule;
    }

    private getFactorValueType(factorId: string) {
        let factor = this.factors[factorId] as Factor
        if (factor) {
            return this.VALUE_TYPES.find(v => factor.valueTypeDefinition
                && v.valueType === factor.valueTypeDefinition.valueType
                && v.valueSubType === factor.valueTypeDefinition.valueSubType)
        }
    }

    private changeFactorValueType(factorId: string, valueTypeInformation: any) {
        let factor = this.factors[factorId] as Factor
        if (!factor.valueTypeDefinition) {
            factor.valueTypeDefinition = {valueType: valueTypeInformation.valueType};
        } else {
            factor.valueTypeDefinition.valueType = valueTypeInformation.valueType;
        }

        factor.valueTypeDefinition.valueSubType = valueTypeInformation.valueSubType;

        switch(valueTypeInformation.valueType) {
            case "CATEGORICAL":
                Vue.set(factor.valueTypeDefinition, 'categoricalValues', []);
                Vue.set(factor.valueTypeDefinition, 'format', "DROP_DOWN");
                break;

            case "DATE_TIME":
                Vue.delete(factor.valueTypeDefinition, 'categoricalValues');
                Vue.set(factor.valueTypeDefinition, 'format', "YYYY-MM-DD");
                break;

            case "TEXT":
                Vue.delete(factor.valueTypeDefinition, 'categoricalValues');
                Vue.set(factor.valueTypeDefinition, 'format', "PLAIN");
                break;
            
            default:
                Vue.delete(factor.valueTypeDefinition, 'categoricalValues');
                Vue.delete(factor.valueTypeDefinition, 'format');
        }
        modellingModule.updateFactorResource(factor)
    }

    private rotateTable() {
        if (this.tableFactorResource.groupTypeDefinition.dominantType === 'ROW') {
            Vue.set(this.tableFactorResource.groupTypeDefinition, 'dominantType', 'COLUMN')
        } else {
            Vue.set(this.tableFactorResource.groupTypeDefinition, 'dominantType', 'ROW')
        }
    }


    private addFactorClick() {
        let newFactor: any = {
            name: "New Column",
            type: 'FACTOR',
            numWeightingDots: 1,
            valueTypeDefinition: {
                list: true,
                valueType: "TEXT",
                format: "PLAIN"
            }
        };
        this.create(newFactor)
    }

    private async create(newFactor: any) {
        this.creating = true;
        await modellingModule.createFactorResource({parentId: this.tableFactorResource.id, factorResource: newFactor})
        this.creating = false;
    }

    private updateFactorName(factorId: string, value: any) {
        this.factors[factorId].name = value;
        modellingModule.updateFactorResource(this.factors[factorId])
    }

    private updateValuePrefix(factorId: string, value: string) {
        let factor = this.factors[factorId] as Factor;
        if (!factor.valueTypeDefinition) return;
        Vue.set(factor.valueTypeDefinition, 'valuePrefix', value);
        modellingModule.updateFactorResource(factor)
    }

    private updateValueSuffix(factorId: string, value: string) {
        let factor = this.factors[factorId] as Factor;
        if (!factor.valueTypeDefinition) return;
        Vue.set(factor.valueTypeDefinition, 'valueSuffix', value);
        modellingModule.updateFactorResource(factor)
    }

    private updateValueFormat(factorId: string, value: string) {
        let factor = this.factors[factorId] as Factor;
        if (!factor.valueTypeDefinition) return;
        Vue.set(factor.valueTypeDefinition, 'format', value);
        modellingModule.updateFactorResource(factor)
    }


    private updateCategoricalValues(factorId: string, values: string[]) {
        let factor = this.factors[factorId] as Factor;
        // if (!factor.valueTypeDefinition) return;
        // Vue.set(factor.valueTypeDefinition, 'format', value);
        modellingModule.updateFactorResource(factor)
    }

    private doesTableContainType(childrenIds: string[], value: string) {
        for (const child of childrenIds) {
            let childFactor = this.factors[child] as Factor;
            if (!childFactor.valueTypeDefinition) continue;
            if (childFactor.valueTypeDefinition.valueType === value) return true
        }

        return false;
    }

    private async deleteResource(resourceId: string) {
        await modellingModule.deleteFactorResource(resourceId);
    }

    private async updateTableFactorResource() {
        await modellingModule.updateFactorResource(this.tableFactorResource);
    }

    @Emit('updated')
    private emitUpdated(resource: any) {
        return resource;
    }
}
